export const TOGGLE_SITE_NAV = 'TOGGLE_SITE_NAV';
export const OPEN_SITE_NAV = 'OPEN_SITE_NAV';
export const CLOSE_SITE_NAV = 'CLOSE_SITE_NAV';

export const TOGGLE_SITE_SEARCH = 'TOGGLE_SITE_SEARCH';
export const OPEN_SITE_SEARCH = 'OPEN_SITE_SEARCH';
export const EDIT_SITE_SEARCH = 'EDIT_SITE_SEARCH';
export const CLOSE_SITE_SEARCH = 'CLOSE_SITE_SEARCH';

export const SAYT_SEARCH = "SAYT_SEARCH";
export const ENHANCED_SAYT_SEARCH = "ENHANCED_SAYT_SEARCH";
export const SAYT_SEARCH_RESULTS = "SAYT_SEARCH_RESULTS";
export const ENHANCED_SAYT_SEARCH_RESULTS = "ENHANCED_SAYT_SEARCH_RESULTS";
export const SAYT_SEARCH_SUBMIT = "SAYT_SEARCH_SUBMIT";
export const SAYT_SEARCH_FAILURE = "SATY_SEARCH_FAILURE";

export const UPDATE_COUNTRY_AND_CURRENCY = "UPDATE_COUNTRY_AND_CURRENCY";

/*
 * Fired when a user taps the hamburger menu on smaller screens
 */
export function toggleSiteNav(shouldOpen) {
    return {
        type: TOGGLE_SITE_NAV,
        payload: {
            shouldOpen: shouldOpen
        }
    };
}

/*
 * Fired when a user taps the search icon on smaller screens
 */
export function toggleSiteSearch(shouldOpen) {
    return {
        type: TOGGLE_SITE_SEARCH,
        payload: {
            shouldOpen: shouldOpen
        }
    };
}

/*
 * Fired when the search field is edited - used to manage the mobile input clear button state
*/
export function editSiteSearch(isClearable, source) {
    return {
        type: EDIT_SITE_SEARCH,
        payload: {
            isClearable: isClearable,
            source: source
        }
    };
}

/*
 * Fired when a user types a search term into the sayt search field
 * @param {String} searchTerm text of the search term
 * @param {string} source     string representing location in store to update data
 * @param {object} e          jquery browser event
 * @return {Object} FSA
 */
export function saytSearch(searchTerm, source, e = {}) {
    return {
        type: SAYT_SEARCH,
        payload: {
            searchTerm: searchTerm,
            source: source
        },
        meta: {
            event: e
        }
    };
}

/*
 * Fired when a user types a search term into the sayt search field for the enhanced search component
 * @param {String} searchTerm text of the search term
 * @param {string} source     string representing location in store to update data
 * @param {object} e          jquery browser event
 * @return {Object} FSA
 */
export function enhancedSaytSearch(searchTerm, source, e = {}) {
    return {
        type: ENHANCED_SAYT_SEARCH,
        payload: {
            searchTerm: searchTerm,
            source: source
        },
        meta: {
            event: e
        }
    };
}

/**
 * Fired from the sayt search saga with the results of the search
 * @param {Array} searchSuggestions array of search suggestions results
 * @param {Array} products          array of products
 * @param {string} source           string representing location in store to update data
 * @param {object} e                jquery browser event
 * @param {boolean} showNoResultsMessage  show the "no results" message
 * @return {Object} FSA
 */
export function saytSearchResults(searchSuggestions, products, source, e = {}, showNoResultsMessage = false) {
    return {
        type: SAYT_SEARCH_RESULTS,
        payload: {
            searchSuggestions: searchSuggestions,
            products: products,
            source: source,
            showNoResultsMessage: showNoResultsMessage
        },
        meta: {
            event: e
        }
    };
}

/**
 * Fired from the sayt search saga with the results of the search (for enhanced SAYT feature)
 * @param {Object} data                 object containing data for different parts of enhanced search
 * @param {Array} data.keywords         keyword strings (search suggestions)
 * @param {Array} data.defaultTrending  trending strings (when enhanced search is first displayed)
 * @param {Array} data.trending         trending strings (for first search suggestion)
 * @param {string} data.searchTerm      the search term that was entered to produce these results
 * @param {Array} products              array of products
 * @param {string} source               string representing location in store to update data
 * @param {object} e                    jquery browser event
 * @param {boolean} showNoResultsMessage  show the "no results" message
 * @return {Object} FSA
 */
export function enhancedSaytSearchResults(data, products, source, e = {}, showNoResultsMessage = false) {
    return {
        type: ENHANCED_SAYT_SEARCH_RESULTS,
        payload: {
            searchSuggestions: _.get(data, 'keywords', []),
            defaultTrending: _.get(data, 'defaultTrending', []),
            trending: _.get(data, 'trending', []),
            searchTerm: _.get(data, 'searchTerm', ''),
            defaultPopularProducts: _.get(data, 'defaultPopularProducts', []),
            popularProducts: products,
            source: source,
            showNoResultsMessage: showNoResultsMessage,
            popularDisplayName: _.get(data, 'popularDisplayName', [])
        },
        meta: {
            event: e
        }
    };
}

/**
 * Fired when the user submits (presses enter) on the search text box
 * @param {String} searchTerm search term from the search input field
 * @param {string} source     string representing location in store to update data
 * @param {object} e          jquery browser event
 * @return {Object} FSA
 */
export function saytSubmitSearch(searchTerm, source, e = {}) {
    return {
        type: SAYT_SEARCH_SUBMIT,
        payload: {
            searchTerm: searchTerm,
            source: source
        },
        meta: {
            event: e
        }
    };
}

/**
 * Fired when the search fails.  TODO: Implement on next pass with products
 * @param {string} source string representing location in store to update data
 * @param {object} e      jquery browser event
 * @return {Object} FSA
 */
export function saytSearchFailure(source, e = {}) {
    return {
        type: SAYT_SEARCH_FAILURE,
        payload: {
            searchSuggestions: [],
            products: [],
            source: source
        },
        meta: {
            event: e
        }
    };
}

export function updateCountryAndCurrency(countryCode, currencyCode, countryDisplayName, currencyFormattingInfo) {
    return {
        type: UPDATE_COUNTRY_AND_CURRENCY,
        payload: {
            country: countryCode,
            countryDisplayName: countryDisplayName,
            currency: currencyCode,
            currencyFormattingInfo: currencyFormattingInfo
        }
    };
}
